import type { DocumentOcrRetakePayload } from '@repo/common';

import { Heading, PrimaryButton } from '@dot/design-system';
import { useTranslation } from 'react-i18next';

import * as SC from '@/components/CaptureServerErrorOverlay/CaptureServerErrorOverlayStyles';
import { useDocumentOcrRetakeText } from '@/utils/document-ocr-retake';
import * as GSC from '@/styles/GlobalStyles';

export type DocumentRetakeOverlayProps = {
  onDismiss: () => void;
  retake: DocumentOcrRetakePayload;
};

export const DocumentRetakeOverlay = ({ onDismiss, retake }: DocumentRetakeOverlayProps) => {
  const { t } = useTranslation();
  const { subtitle, title, tryAgainButton } = useDocumentOcrRetakeText(retake.reason_code);

  const attemptLabel =
    retake.retake_limit > 0
      ? t('steps.documentCapture.retake.attemptLabel', {
          current: retake.retake_count,
          limit: retake.retake_limit,
        })
      : '';

  return (
    <GSC.InfoContainer style={{ pointerEvents: 'auto' }}>
      <GSC.DarkOverlay />
      <SC.Instruction>
        <Heading as="h3">{title}</Heading>
        <SC.Subtitle>{subtitle}</SC.Subtitle>
        {attemptLabel ? <SC.Subtitle>{attemptLabel}</SC.Subtitle> : null}
        <SC.ButtonRow>
          <PrimaryButton colorVariant="aqua" onClick={onDismiss} size="sm" type="button">
            {tryAgainButton}
          </PrimaryButton>
        </SC.ButtonRow>
      </SC.Instruction>
    </GSC.InfoContainer>
  );
};
